import React, { useState, useEffect } from "react";
import axios from "axios";
import { useSelector } from "react-redux";
import { useParams, useNavigate } from "react-router-dom";
import { Container, Form, Button, Card } from "react-bootstrap";
import Layout from "../layout";
import SuccessModalOrder from "../../component/ModalSuccessOrder";

const PerusahaanTransaksi = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    hargaaktual: "",
    catatanharga: "",
  });
  const [msg, setMsg] = useState("");
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      const token = localStorage.getItem("token");

      if (!token) {
        setMsg("No token found, please login again.");
        return;
      }

      try {
        const response = await axios.get(
          `https://c-greenproject.org:8000/orderberlangsung`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        const data = response.data;
        setFormData({
          hargaaktual: data.hargaaktual || "",
          catatanharga: data.catatanharga || "",
        });
      } catch (error) {
        console.error("Error fetching data:", error);
        if (error.response) {
          setMsg(
            `Error: ${error.response.data.message || error.response.statusText}`
          );
        } else {
          setMsg("Error fetching data.");
        }
      }
    };

    console.log("Order ID:", id);
    fetchData();
  }, [id]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const token = localStorage.getItem("token");

    if (!token) {
      setMsg("No token found, please login again.");
      return;
    }

    try {
      await axios.patch(
        `https://c-greenproject.org:8000/inputtransaksi/${id}`,
        {
          ...formData,
          status: "Order berhasil diperbarui menjadi order selesai",
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setShowModal(true);
      
    } catch (error) {
      if (error.response) {
        setMsg(
          `Error: ${error.response.data.message || error.response.statusText}`
        );
      } else {
        setMsg("Error updating data.");
      }
      console.error("Error updating data:", error);
    }
  };

  return (
    <Layout>
      <Container>
        <nav aria-label="breadcrumb pb-0">
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <a href="/order">Order Aktif</a>
            </li>
            <li className="breadcrumb-item active" aria-current="page">
              Order Selesai
            </li>
          </ol>
        </nav>
        <h2 className="my-4">
          <strong>Update Data Penerimaan Singkong</strong>
        </h2>
        <Card className="p-4 mb-3">
          <Form onSubmit={handleSubmit}>
            {msg && <p className="text-center text-danger">{msg}</p>}

            <Form.Group className="mb-3">
              <Form.Label>Harga Aktual (Rp)</Form.Label>
              <Form.Control
                type="number"
                name="hargaaktual"
                value={formData.hargaaktual}
                onChange={handleChange}
                placeholder="Masukkan harga aktual"
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Catatan Harga</Form.Label>
              <Form.Control
                as="textarea"
                name="catatanharga"
                value={formData.catatanharga}
                onChange={handleChange}
                placeholder="Masukkan catatan harga"
                rows={3}
              />
            </Form.Group>

            <Button variant="success" type="submit">
              Update
            </Button>
          </Form>
        </Card>
      </Container>
      <SuccessModalOrder
        show={showModal}
        onClose={() => setShowModal(false)}
        message="Order dinyatakan selesai oleh perusahaan."
      />
    </Layout>
  );
};

export default PerusahaanTransaksi;
